import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import DPlayer from '../../../../../assets/js/dplayer_mod.js';

declare global {
  interface Window {
    Hls?: any;
  }
}

@Component({
  selector: 'app-streampublic',
  templateUrl: './streampublic.component.html',
  styleUrls: ['./streampublic.component.css']
})
export class StreampublicComponent implements OnInit, OnDestroy {

  @Input('id') id : any;
  @Input('url') url : any;
  @Input('child') child : any;
  @Input('maintenanceImage') maintenanceImage : string; // Imagen personalizada opcional

  showMaintenanceImage: boolean = false;
  maintenanceImagePath: string = 'assets/cameras/streaming/claro-mantenimiento.jpg';
  
  // Getter para debug
  get shouldShowImage(): boolean {
    return this.showMaintenanceImage;
  }
  private loadingTimeout: any;
  private loadingCheckInterval: any;
  private earlyCheckInterval: any;
  private dp: any;
  private videoElement: HTMLVideoElement | null = null;
  private isVideoPlaying: boolean = false;
  private loadStartTime: number = 0;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    console.log('🚀 StreampublicComponent ngOnInit iniciado');
    
    // Listener global para detectar errores 404 en las peticiones de red
    // Esto captura errores que pueden no propagarse al elemento de video
    const self = this;
    
    // Interceptar fetch (usado por algunos navegadores modernos)
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      return originalFetch.apply(this, args).then((response) => {
        // Verificar si es una petición a un archivo .m3u8
        const url = args[0] as string;
        if (url && typeof url === 'string' && url.includes('.m3u8')) {
          if (!response.ok) {
            console.error('❌ Error', response.status, 'detectado en fetch para:', url);
            // Esperar un poco para que el componente se inicialice
            setTimeout(() => {
              if (!self.isVideoPlaying) {
                console.warn('⚠️ Mostrando imagen de mantenimiento por error en fetch');
                self.showMaintenanceImage = true;
                self.cdr.detectChanges();
                self.createMaintenanceImageInDOM();
                self.clearLoadingChecks();
              }
            }, 2000);
          }
        }
        return response;
      }).catch((error) => {
        const url = args[0] as string;
        if (url && typeof url === 'string' && url.includes('.m3u8')) {
          console.error('❌ Error en fetch para .m3u8:', url, error);
          setTimeout(() => {
            if (!self.isVideoPlaying) {
              console.warn('⚠️ Mostrando imagen de mantenimiento por error en fetch');
              self.showMaintenanceImage = true;
              self.cdr.detectChanges();
              self.createMaintenanceImageInDOM();
              self.clearLoadingChecks();
            }
          }, 2000);
        }
        throw error;
      });
    };
    
    // Interceptar XMLHttpRequest (usado por HLS.js y otros)
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;
    const self2 = this;
    
    XMLHttpRequest.prototype.open = function(method: string, url: string | URL, ...rest: any[]) {
      this._url = url;
      return originalXHROpen.apply(this, [method, url, ...rest]);
    };
    
    XMLHttpRequest.prototype.send = function(...args: any[]) {
      const xhr = this;
      const url = xhr._url;
      
      if (url && typeof url === 'string' && url.includes('.m3u8')) {
        xhr.addEventListener('error', function() {
          console.error('❌ Error en XMLHttpRequest para .m3u8:', url);
          setTimeout(() => {
            if (!self2.isVideoPlaying) {
              console.warn('⚠️ Mostrando imagen de mantenimiento por error en XMLHttpRequest');
              self2.showMaintenanceImage = true;
              self2.cdr.detectChanges();
              self2.createMaintenanceImageInDOM();
              self2.clearLoadingChecks();
            }
          }, 2000);
        });
        
        xhr.addEventListener('load', function() {
          if (xhr.status >= 400) {
            console.error('❌ Error', xhr.status, 'en XMLHttpRequest para .m3u8:', url);
            setTimeout(() => {
              if (!self2.isVideoPlaying) {
                console.warn('⚠️ Mostrando imagen de mantenimiento por error', xhr.status, 'en XMLHttpRequest');
                self2.showMaintenanceImage = true;
                self2.cdr.detectChanges();
                self2.createMaintenanceImageInDOM();
                self2.clearLoadingChecks();
              }
            }, 2000);
          }
        });
      }
      
      return originalXHRSend.apply(this, args);
    };
  }

  ngAfterViewInit(){
    console.log('🚀 StreampublicComponent ngAfterViewInit iniciado');
    console.log('🚀 ID:', this.id);
    console.log('🚀 URL:', this.url);
    console.log('🚀 Child:', this.child);
    
    // Determinar qué imagen de mantenimiento usar (aquí el ID ya está disponible)
    this.determineMaintenanceImage();
    
    var IsiPhone = navigator.userAgent.indexOf("iPhone") != -1 ;
    var IsiPod = navigator.userAgent.indexOf("iPod") != -1 ;
    var IsiPad = navigator.userAgent.indexOf("iPad") != -1 ;

    var IsiPhoneOS = IsiPhone || IsiPad || IsiPod ;
    var video;
    //var url = "https://live.smartechlatam.online/claro/chimbotetest";
    //if (IsiPhoneOS) {
      video = {
	      quality: [
            {
                name: 'HD',
                url: this.url+'/index.m3u8',
                type: 'hls',
            },
            {
                name: '480',
                url: this.url +'_480/index.m3u8',
                type: 'hls',
            },
            {
                name: '720',
                url: this.url +'_720/index.m3u8',
                type: 'hls',
            },
        ],
        defaultQuality: 0,
      }
    /*} else {
      video = {
	      quality: [
            /*{
                name: 'HD',
                url: url+'.flv',
                type: 'flv',
            },
            {
                name: '480',
                url: url+'_480.flv',
                type: 'flv',
            },
            {
                name: '720',
                url:this.url+'.flv',
                type: 'flv',
            },
        ],
        defaultQuality: 0,
      }
    //}*/

    var myVideo = document.getElementById( this.id )
    console.log('🚀 Contenedor de video encontrado:', !!myVideo);
    
    if (!myVideo) {
      console.error('❌ No se encontró el contenedor de video con id:', this.id);
      // Intentar de nuevo después de un delay
      setTimeout(() => {
        myVideo = document.getElementById( this.id );
        if (myVideo) {
          console.log('✅ Contenedor encontrado en segundo intento');
          this.initializeDPlayer(myVideo, video);
        } else {
          console.error('❌ Contenedor aún no encontrado después del delay');
        }
      }, 500);
      return;
    }
    
    this.initializeDPlayer(myVideo, video);
  }
  
  private initializeDPlayer(myVideo: HTMLElement, video: any) {
    console.log('🚀 Inicializando DPlayer...');
    
    this.dp = new DPlayer({
      container: myVideo,
      screenshot: false,
      live: !this.child,
      preload: 'auto',
      autoplay: !this.child,
      airplay: !this.child,
      mutex: false,
      hotkey: false,
      video: video,
      volume:0
    });
    
    console.log('✅ DPlayer inicializado');

    if(this.child){
      const dplayerElement = myVideo.querySelector('.dplayer');
      if (dplayerElement) {
        dplayerElement.classList.remove('dplayer-controller');
      }
    }

    // Función para obtener el elemento de video
    const getVideoElement = (): HTMLVideoElement | null => {
      if (!this.videoElement) {
        // Intentar obtener el video desde DPlayer primero
        if (this.dp && this.dp.video) {
          this.videoElement = this.dp.video;
        } else {
          // Si no está disponible en DPlayer, buscar en el DOM
          this.videoElement = myVideo.querySelector('video') as HTMLVideoElement;
        }
      }
      return this.videoElement;
    };

    // Función para forzar autoplay
    const forceAutoplay = () => {
      const videoEl = getVideoElement();
      if (videoEl && !this.child) {
        // Asegurar que el video esté muted para permitir autoplay (requerido por navegadores)
        videoEl.muted = true;
        videoEl.volume = 0;
        videoEl.setAttribute('muted', 'true');
        videoEl.setAttribute('playsinline', 'true');
        videoEl.setAttribute('autoplay', 'true');
        
        // Intentar reproducir inmediatamente
        const tryPlay = () => {
          if (videoEl && videoEl.paused) {
            const playPromise = videoEl.play();
            if (playPromise !== undefined) {
              playPromise.then(() => {
                // Reproducción exitosa
                console.log('Autoplay exitoso');
                this.isVideoPlaying = true;
                this.showMaintenanceImage = false;
                this.clearLoadingChecks();
              }).catch((error) => {
                // Error al reproducir - puede ser política del navegador
                console.warn('Autoplay bloqueado:', error);
                // Usar DPlayer para reproducir si está disponible
                if (this.dp && this.dp.play) {
                  try {
                    this.dp.play();
                    this.isVideoPlaying = true;
                    this.showMaintenanceImage = false;
                  } catch (e) {
                    console.warn('No se pudo reproducir con DPlayer:', e);
                  }
                }
              });
            }
          }
        };
        
        // Intentar reproducir inmediatamente
        tryPlay();
        
        // Reintentar después de un pequeño delay
        setTimeout(tryPlay, 100);
        setTimeout(tryPlay, 500);
        setTimeout(tryPlay, 1000);
      }
    };
    
    // Detectar errores de carga del video desde DPlayer
    this.dp.on('error', () => {
      console.error('Error en DPlayer');
      this.showMaintenanceImage = true;
      this.cdr.detectChanges();
      this.createMaintenanceImageInDOM();
      this.clearLoadingChecks();
    });

    // Intentar detectar errores de HLS directamente si está disponible
    if (window.Hls && window.Hls.isSupported()) {
      // Esperar a que HLS se inicialice y agregar listeners de error
      setTimeout(() => {
        try {
          // Intentar acceder a la instancia de HLS a través de DPlayer
          const hlsInstance = this.dp.plugins && this.dp.plugins.hls;
          if (hlsInstance) {
            // Escuchar eventos de error de HLS directamente
            hlsInstance.on(window.Hls.Events.ERROR, (event: any, data: any) => {
              console.error('Error en HLS:', data);
              // Si es un error fatal o de red (404, etc.), mostrar imagen
              if (data.fatal || data.type === 'networkError' || data.type === 'manifestLoadError' || data.details === 'manifestLoadError') {
                console.error('Error fatal de HLS detectado, mostrando imagen de mantenimiento');
                this.showMaintenanceImage = true;
                this.cdr.detectChanges();
                this.createMaintenanceImageInDOM();
                this.clearLoadingChecks();
              }
            });
          }
        } catch (e) {
          console.warn('No se pudo acceder a instancia de HLS:', e);
        }
      }, 1000);
    }

    // Agregar listeners al elemento de video cuando esté disponible
    const setupVideoListeners = () => {
      const videoEl = getVideoElement();
      if (videoEl) {
        // Guardar tiempo de inicio de carga
        this.loadStartTime = Date.now();
        
        // Asegurar muted para autoplay
        videoEl.muted = true;
        videoEl.setAttribute('muted', 'true');
        videoEl.setAttribute('playsinline', 'true');

        videoEl.addEventListener('loadstart', () => {
          this.loadStartTime = Date.now();
        });

        videoEl.addEventListener('error', (e) => {
          console.error('Error en video:', e);
          const videoError = videoEl.error;
          if (videoError) {
            // Verificar el código de error
            // MEDIA_ERR_ABORTED = 1, MEDIA_ERR_NETWORK = 2, MEDIA_ERR_DECODE = 3, MEDIA_ERR_SRC_NOT_SUPPORTED = 4
            console.error('Código de error del video:', videoError.code, 'Mensaje:', videoError.message);
            if (videoError.code === 2 || videoError.code === 4 || videoError.code === 1) {
              // Error de red (404, conexión, etc.) o fuente no soportada
              console.error('Error de red o fuente no encontrada, mostrando imagen de mantenimiento');
              this.showMaintenanceImage = true;
              this.cdr.detectChanges();
              this.createMaintenanceImageInDOM();
              this.clearLoadingChecks();
            } else {
              // Otros errores también mostrar imagen
              console.error('Otro tipo de error, mostrando imagen de mantenimiento');
              this.showMaintenanceImage = true;
              this.cdr.detectChanges();
              this.createMaintenanceImageInDOM();
              this.clearLoadingChecks();
            }
          } else {
            // Si hay error pero no hay código, mostrar imagen de todas formas
            console.error('Error sin código, mostrando imagen de mantenimiento');
            this.showMaintenanceImage = true;
            this.cdr.detectChanges();
            this.createMaintenanceImageInDOM();
            this.clearLoadingChecks();
          }
        });

        videoEl.addEventListener('loadeddata', () => {
          this.clearLoadingChecks();
          this.showMaintenanceImage = false;
          if (!this.child) {
            forceAutoplay();
          }
        });

        videoEl.addEventListener('canplay', () => {
          this.clearLoadingChecks();
          this.showMaintenanceImage = false;
          if (!this.child) {
            forceAutoplay();
          }
        });

        videoEl.addEventListener('playing', () => {
          this.isVideoPlaying = true;
          this.clearLoadingChecks();
          this.showMaintenanceImage = false;
        });

        videoEl.addEventListener('waiting', () => {
          // El video está esperando datos
          if (!this.isVideoPlaying) {
            // Si no ha comenzado a reproducir, iniciar verificación
            this.startLoadingCheck();
          }
        });

        videoEl.addEventListener('stalled', () => {
          // El video se ha detenido por falta de datos
          if (!this.isVideoPlaying) {
            this.startLoadingCheck();
          }
        });

        // Intentar forzar autoplay inmediatamente
        if (!this.child) {
          setTimeout(() => {
            forceAutoplay();
          }, 500);
        }

        return true;
      }
      return false;
    };

    // Iniciar tiempo de carga ahora
    this.loadStartTime = Date.now();

    // Intentar configurar listeners con múltiples intentos
    let attempts = 0;
    const maxAttempts = 20; // Aumentado para dar más tiempo
    const trySetup = () => {
      const success = setupVideoListeners();
      if (!success && attempts < maxAttempts) {
        attempts++;
        setTimeout(trySetup, 100); // Verificar más frecuentemente
      } else if (success) {
        // Si se configuró correctamente, iniciar verificación de carga
        setTimeout(() => {
          this.startLoadingCheck();
        }, 1000);
        // Forzar autoplay después de configurar listeners
        if (!this.child) {
          setTimeout(() => {
            forceAutoplay();
          }, 500);
        }
      }
    };
    trySetup();
    
    // También intentar obtener el video directamente desde DPlayer después de un delay
    setTimeout(() => {
      if (this.dp && this.dp.video && !this.videoElement) {
        this.videoElement = this.dp.video;
        setupVideoListeners();
        if (!this.child) {
          forceAutoplay();
        }
      }
    }, 500);

    // Iniciar verificación de carga inmediatamente
    setTimeout(() => {
      if (!this.isVideoPlaying) {
        this.startLoadingCheck();
      }
    }, 1000);

    // Verificación MUY agresiva: Si después de 2 segundos el readyState es 0, mostrar imagen
    // Esto captura errores 404 que ocurren en zone-evergreen.js pero no se propagan al video
    setTimeout(() => {
      console.log('🔍 Verificación a los 2 segundos...');
      const videoEl = getVideoElement();
      console.log('🔍 Elemento de video encontrado:', !!videoEl);
      if (videoEl) {
        console.log('🔍 readyState:', videoEl.readyState);
        console.log('🔍 isVideoPlaying:', this.isVideoPlaying);
        console.log('🔍 showMaintenanceImage antes:', this.showMaintenanceImage);
        console.log('🔍 currentTime:', videoEl.currentTime);
        console.log('🔍 paused:', videoEl.paused);
        
        // Si el readyState es 0 después de 2 segundos, mostrar imagen SIEMPRE
        // NO importa si isVideoPlaying es true o false, si readyState es 0 es un error
        if (videoEl.readyState === 0 || videoEl.error) {
          console.warn('⚠️ Video sin datos después de 2 segundos (readyState: 0 o error) - Probable error 404');
          console.warn('⚠️ FORZANDO mostrar imagen de mantenimiento');
          this.showMaintenanceImage = true;
          this.isVideoPlaying = false;
          
          // Forzar detección de cambios
          this.cdr.detectChanges();
          
          // También forzar directamente en el DOM como respaldo
          console.log('🔧 Llamando a createMaintenanceImageInDOM desde timeout de 2 segundos...');
          this.createMaintenanceImageInDOM();
          this.clearLoadingChecks();
        }
      } else {
        console.warn('⚠️ No se encontró elemento de video a los 2 segundos - Mostrando imagen');
        this.showMaintenanceImage = true;
        this.cdr.detectChanges();
        console.log('🔧 Llamando a createMaintenanceImageInDOM desde timeout de 2 segundos (sin video)...');
        this.createMaintenanceImageInDOM();
        this.clearLoadingChecks();
      }
    }, 2000);
    
    // Verificación temprana y agresiva de errores
    // Verificar cada 500ms si el video tiene problemas
    this.earlyCheckInterval = setInterval(() => {
      const videoEl = getVideoElement();
      const timeSinceLoad = this.loadStartTime > 0 ? Date.now() - this.loadStartTime : 0;
      
      if (videoEl) {
        // REGLA PRINCIPAL: Si después de 2 segundos el readyState es 0, mostrar imagen SIEMPRE
        // NO importa si isVideoPlaying es true, si readyState es 0 es un error
        // Esto captura errores 404 que no se propagan correctamente desde zone-evergreen.js
        if (timeSinceLoad > 2000 && videoEl.readyState === 0) {
          console.warn('⚠️ [INTERVALO] Video sin datos (readyState: 0) después de', timeSinceLoad, 'ms');
          this.showMaintenanceImage = true;
          this.isVideoPlaying = false;
          this.cdr.detectChanges();
          
          // Forzar directamente en el DOM
          this.createMaintenanceImageInDOM();
          
          this.clearLoadingChecks();
          return;
        }
        
        // Verificar si hay error
        if (videoEl.error) {
          const errorCode = videoEl.error.code;
          console.error('❌ Error detectado en video (código:', errorCode, ') - Mostrando imagen');
          this.showMaintenanceImage = true;
          this.cdr.detectChanges();
          this.createMaintenanceImageInDOM();
          this.clearLoadingChecks();
          return;
        }
        
        // Si después de 3 segundos no hay datos y no está reproduciendo, mostrar imagen
        if (timeSinceLoad > 3000 && videoEl.currentTime === 0 && videoEl.readyState < 2 && !this.isVideoPlaying) {
          console.warn('⚠️ Video sin datos después de 3 segundos - Mostrando imagen');
          this.showMaintenanceImage = true;
          this.cdr.detectChanges();
          this.createMaintenanceImageInDOM();
          this.clearLoadingChecks();
          return;
        }
      } else if (!videoEl && timeSinceLoad > 2000) {
        // Si no hay elemento de video después de 2 segundos, mostrar imagen
        console.warn('⚠️ No se encontró elemento de video después de 2 segundos - Mostrando imagen');
        this.showMaintenanceImage = true;
        this.cdr.detectChanges();
        this.createMaintenanceImageInDOM();
        this.clearLoadingChecks();
        return;
      }
      
      // Limpiar el intervalo después de 10 segundos
      if (timeSinceLoad > 10000) {
        if (this.earlyCheckInterval) {
          clearInterval(this.earlyCheckInterval);
          this.earlyCheckInterval = null;
        }
      }
    }, 500);

    // Si el video comienza a reproducir, cancelar las verificaciones
    this.dp.on('play', () => {
      this.isVideoPlaying = true;
      this.clearLoadingChecks();
      this.showMaintenanceImage = false;
    });

    // Detectar cuando el video tiene datos suficientes para reproducir
    this.dp.on('canplay', () => {
      this.clearLoadingChecks();
      this.showMaintenanceImage = false;
      if (!this.child) {
        forceAutoplay();
      }
    });
  }

  private startLoadingCheck() {
    // Limpiar cualquier verificación anterior
    this.clearLoadingChecks();

    // Si no tenemos tiempo de inicio, establecerlo ahora
    if (this.loadStartTime === 0) {
      this.loadStartTime = Date.now();
    }

    // Verificar cada segundo si el video está cargando sin reproducir
    this.loadingCheckInterval = setInterval(() => {
      const container = document.getElementById(this.id);
      const videoEl = this.videoElement || (container ? container.querySelector('video') as HTMLVideoElement : null);
      
      if (videoEl) {
        // Verificar primero si hay un error en el video
        if (videoEl.error) {
          const errorCode = videoEl.error.code;
          // MEDIA_ERR_NETWORK = 2 (404, conexión, etc.), MEDIA_ERR_SRC_NOT_SUPPORTED = 4
          if (errorCode === 2 || errorCode === 4 || errorCode === 1) {
            this.showMaintenanceImage = true;
            this.cdr.detectChanges();
            this.createMaintenanceImageInDOM();
            this.clearLoadingChecks();
            return;
          }
        }

        // Verificar si el video está realmente reproduciendo o tiene datos
        const isActuallyPlaying = !videoEl.paused && 
                                  !videoEl.ended && 
                                  videoEl.currentTime > 0 && 
                                  videoEl.readyState >= 2;
        
        // Si no está reproduciendo después de varios segundos, mostrar imagen de mantenimiento
        if (!isActuallyPlaying && !this.isVideoPlaying) {
          // Verificar si ha pasado suficiente tiempo desde que se inició la carga
          const timeSinceLoad = Date.now() - this.loadStartTime;
          
          // Si han pasado más de 3 segundos sin datos
          if (timeSinceLoad > 3000) {
            // Si el readyState es 0 (sin información) o hay error, mostrar imagen inmediatamente
            if (videoEl.readyState === 0) {
              console.warn('Mostrando imagen de mantenimiento - readyState: 0 después de', timeSinceLoad, 'ms');
              this.showMaintenanceImage = true;
              this.cdr.detectChanges();
              this.createMaintenanceImageInDOM();
              this.clearLoadingChecks();
            } else if (videoEl.error) {
              console.warn('Mostrando imagen de mantenimiento - error detectado:', videoEl.error.code);
              this.showMaintenanceImage = true;
              this.cdr.detectChanges();
              this.createMaintenanceImageInDOM();
              this.clearLoadingChecks();
            } else if (timeSinceLoad > 5000 && !isActuallyPlaying) {
              // Si después de 5 segundos aún no está reproduciendo, mostrar imagen
              console.warn('Mostrando imagen de mantenimiento - sin reproducción después de', timeSinceLoad, 'ms');
              this.showMaintenanceImage = true;
              this.cdr.detectChanges();
              this.createMaintenanceImageInDOM();
              this.clearLoadingChecks();
            }
          }
        } else if (isActuallyPlaying) {
          // Si está reproduciendo, ocultar imagen y limpiar verificaciones
          this.isVideoPlaying = true;
          this.showMaintenanceImage = false;
          this.clearLoadingChecks();
        }
      } else {
        // Si no hay elemento de video después de un tiempo, mostrar imagen
        const timeSinceLoad = Date.now() - this.loadStartTime;
        if (timeSinceLoad > 10000) {
          this.showMaintenanceImage = true;
          this.cdr.detectChanges();
          this.createMaintenanceImageInDOM();
          this.clearLoadingChecks();
        }
      }
    }, 1000);

    // Timeout de seguridad: después de 5 segundos, si no hay reproducción, mostrar imagen
    // Reducido para detectar errores 404 más rápido
    this.loadingTimeout = setTimeout(() => {
      const container = document.getElementById(this.id);
      const videoEl = this.videoElement || (container ? container.querySelector('video') as HTMLVideoElement : null);
      if (videoEl && !this.isVideoPlaying) {
        // Verificar primero si hay error
        if (videoEl.error) {
          const errorCode = videoEl.error.code;
          if (errorCode === 2 || errorCode === 4 || errorCode === 1) {
            this.showMaintenanceImage = true;
            this.clearLoadingChecks();
            return;
          }
        }

        const isActuallyPlaying = !videoEl.paused && 
                                  !videoEl.ended && 
                                  videoEl.currentTime > 0 && 
                                  videoEl.readyState >= 2;
        
        if (!isActuallyPlaying) {
          console.warn('Timeout: Video no está reproduciendo después de 5 segundos');
          this.showMaintenanceImage = true;
          this.cdr.detectChanges();
          this.createMaintenanceImageInDOM();
          this.clearLoadingChecks();
        }
      } else if (!videoEl) {
        // Si no hay elemento de video, mostrar imagen
        console.warn('Timeout: No se encontró elemento de video');
        this.showMaintenanceImage = true;
        this.cdr.detectChanges();
        this.createMaintenanceImageInDOM();
        this.clearLoadingChecks();
      }
    }, 5000);
  }

  private determineMaintenanceImage() {
    // Si se proporciona una imagen personalizada, usarla
    if (this.maintenanceImage) {
      this.maintenanceImagePath = this.maintenanceImage;
      return;
    }
    
    // Lista de IDs de cámaras que deben usar la imagen de muni-lima
    // Solo se usa muni-lima-mantenimiento.jpg si el ID coincide exactamente
    const muniLimaCameraIds: number[] = [
      299, 298, 297, 300, 296, 295
    ];
    
    const cameraId = this.id;
    // Extraer solo el número del ID (puede venir como "stream_294" o solo "294")
    let cameraIdNum: number | null = null;
    let cameraIdStr = '';
    
    if (cameraId != null) {
      const idStr = String(cameraId).trim();
      // Si tiene prefijo "stream_", extraer solo el número
      const match = idStr.match(/(\d+)$/);
      if (match) {
        cameraIdNum = Number(match[1]);
        cameraIdStr = match[1];
      } else {
        // Si no tiene prefijo, intentar convertir directamente
        cameraIdNum = Number(idStr);
        cameraIdStr = idStr;
      }
    }
    
    console.log('🔍 [determineMaintenanceImage] ID recibido:', cameraId, 'Tipo:', typeof cameraId);
    console.log('🔍 [determineMaintenanceImage] Número extraído:', cameraIdNum, 'String extraído:', cameraIdStr);
    console.log('🔍 [determineMaintenanceImage] IDs muni-lima:', muniLimaCameraIds);
    
    // Verificar si el ID está en la lista de cámaras muni-lima (solo comparar el número)
    let isMuniLimaById = false;
    
    if (cameraIdNum !== null && !isNaN(cameraIdNum)) {
      // Comparar solo el número extraído
      isMuniLimaById = muniLimaCameraIds.indexOf(cameraIdNum) !== -1;
      console.log('🔍 [determineMaintenanceImage] Comparación numérica:', cameraIdNum, 'en lista:', isMuniLimaById);
    }
    
    console.log('🔍 [determineMaintenanceImage] ¿Es muni-lima?', isMuniLimaById);
    
    if (isMuniLimaById) {
      this.maintenanceImagePath = 'assets/cameras/streaming/muni-lima-mantenimiento.jpg';
      console.log('✅ [determineMaintenanceImage] USANDO muni-lima-mantenimiento.jpg para cámara ID:', cameraId);
    } else {
      // Imagen por defecto cuando hay error
      this.maintenanceImagePath = 'assets/cameras/streaming/claro-mantenimiento.jpg';
      console.log('✅ [determineMaintenanceImage] USANDO claro-mantenimiento.jpg para cámara ID:', cameraId);
    }
    
    console.log('🖼️ [determineMaintenanceImage] Imagen final:', this.maintenanceImagePath);
  }

  private clearLoadingChecks() {
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
    if (this.loadingCheckInterval) {
      clearInterval(this.loadingCheckInterval);
      this.loadingCheckInterval = null;
    }
    if (this.earlyCheckInterval) {
      clearInterval(this.earlyCheckInterval);
      this.earlyCheckInterval = null;
    }
  }

  private createMaintenanceImageInDOM() {
    console.log('🔧 createMaintenanceImageInDOM() llamado');
    const container = document.getElementById(this.id);
    if (!container) {
      console.warn('⚠️ No se encontró contenedor con id:', this.id);
      // Intentar buscar por clase también
      const containerByClass = document.querySelector('[id*="' + this.id + '"]');
      if (containerByClass) {
        console.log('✅ Contenedor encontrado por búsqueda alternativa');
      }
      return;
    }
    
    console.log('✅ Contenedor encontrado:', container.id);
    const parentInfo = container.parentElement ? (container.parentElement.className || container.parentElement.tagName) : 'sin padre';
    console.log('✅ Contenedor padre:', parentInfo);
    
    // Buscar el contenedor padre que tenga position relative o .video-streaming
    let parentContainer = container.parentElement;
    let foundVideoStreaming = false;
    let searchDepth = 0;
    
    // Buscar .video-streaming primero (usado en ViewStreamingComponent)
    console.log('🔍 Buscando contenedor .video-streaming...');
    while (parentContainer && parentContainer !== document.body && searchDepth < 10) {
      console.log('🔍 Nivel', searchDepth, ':', parentContainer.className || parentContainer.tagName);
      if (parentContainer.classList.contains('video-streaming')) {
        foundVideoStreaming = true;
        console.log('✅ Encontrado .video-streaming en nivel', searchDepth);
        break;
      }
      parentContainer = parentContainer.parentElement;
      searchDepth++;
    }
    
    // Si no encontramos .video-streaming, buscar cualquier contenedor con position relative
    if (!foundVideoStreaming) {
      console.log('🔍 No se encontró .video-streaming, buscando contenedor con position relative...');
      parentContainer = container.parentElement;
      searchDepth = 0;
      while (parentContainer && parentContainer !== document.body && searchDepth < 10) {
        const style = window.getComputedStyle(parentContainer);
        console.log('🔍 Nivel', searchDepth, 'position:', style.position, parentContainer.className || parentContainer.tagName);
        if (style.position === 'relative' || style.position === 'absolute') {
          console.log('✅ Encontrado contenedor con position:', style.position);
          break;
        }
        parentContainer = parentContainer.parentElement;
        searchDepth++;
      }
    }
    
    // Si aún no encontramos nada, usar el padre directo
    if (!parentContainer || parentContainer === document.body) {
      console.log('🔍 Usando contenedor padre directo');
      parentContainer = container.parentElement;
    }
    
    if (parentContainer) {
      console.log('✅ Contenedor padre final:', parentContainer.className || parentContainer.tagName);
      
      // Asegurar que el contenedor padre tenga position relative
      const parentStyle = window.getComputedStyle(parentContainer);
      console.log('🔍 Estilos del contenedor padre - position:', parentStyle.position, 'width:', parentStyle.width, 'height:', parentStyle.height);
      
      if (parentStyle.position === 'static') {
        parentContainer.style.position = 'relative';
        console.log('✅ Establecido position: relative en contenedor');
      }
      
      // Asegurar que tenga altura mínima y ocupe todo el espacio disponible
      const heightValue = parseInt(parentStyle.height);
      const videoElement = parentContainer.querySelector('.video') as HTMLElement;
      
      // Si hay un elemento de video, usar su altura como referencia
      if (videoElement) {
        const videoHeight = videoElement.offsetHeight || videoElement.clientHeight;
        if (videoHeight > 0) {
          parentContainer.style.height = videoHeight + 'px';
          console.log('✅ Establecido height basado en video:', videoHeight + 'px');
        } else {
          parentContainer.style.minHeight = '400px';
          parentContainer.style.height = '100%';
          console.log('✅ Establecido minHeight: 400px y height: 100%');
        }
      } else {
        if (isNaN(heightValue) || heightValue < 200) {
          parentContainer.style.minHeight = '400px';
          parentContainer.style.height = '100%';
          console.log('✅ Establecido minHeight: 400px y height: 100%');
        }
      }
      
      let imgContainer = parentContainer.querySelector('.maintenance-image-container') as HTMLElement;
      if (!imgContainer) {
        // Crear el contenedor si no existe
        console.log('🔧 Creando nuevo contenedor de imagen...');
        imgContainer = document.createElement('div');
        imgContainer.className = 'maintenance-image-container';
        imgContainer.style.cssText = 'position: absolute !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: 100% !important; height: 100% !important; min-height: 400px !important; display: flex !important; align-items: center !important; justify-content: center !important; background-color: transparent !important; z-index: 10000 !important; pointer-events: none !important; overflow: hidden !important;';
        
        const img = document.createElement('img');
        img.src = this.maintenanceImagePath;
        img.alt = 'Cámara en mantenimiento';
        img.style.cssText = 'width: 100% !important; height: 100% !important; object-fit: cover !important; object-position: center !important;';
        img.onload = () => {
          console.log('✅ Imagen de mantenimiento cargada correctamente');
        };
        img.onerror = () => {
          console.error('❌ Error al cargar imagen de mantenimiento:', this.maintenanceImagePath);
        };
        imgContainer.appendChild(img);
        
        parentContainer.appendChild(imgContainer);
        console.log('✅ Contenedor de imagen creado directamente en el DOM');
        console.log('✅ Dimensiones del contenedor padre:', parentContainer.offsetWidth, 'x', parentContainer.offsetHeight);
        console.log('✅ Dimensiones del contenedor de imagen:', imgContainer.offsetWidth, 'x', imgContainer.offsetHeight);
        
        // Verificar que esté visible
        setTimeout(() => {
          const computedStyle = window.getComputedStyle(imgContainer);
          console.log('🔍 Estilos computados del contenedor de imagen:');
          console.log('  - display:', computedStyle.display);
          console.log('  - visibility:', computedStyle.visibility);
          console.log('  - opacity:', computedStyle.opacity);
          console.log('  - z-index:', computedStyle.zIndex);
          console.log('  - position:', computedStyle.position);
        }, 100);
      } else {
        console.log('✅ Contenedor de imagen ya existe, actualizando estilos...');
        imgContainer.style.display = 'flex';
        imgContainer.style.zIndex = '10000';
        imgContainer.style.position = 'absolute';
        imgContainer.style.top = '0';
        imgContainer.style.left = '0';
        imgContainer.style.right = '0';
        imgContainer.style.bottom = '0';
        imgContainer.style.width = '100%';
        imgContainer.style.height = '100%';
        imgContainer.style.visibility = 'visible';
        imgContainer.style.opacity = '1';
        imgContainer.style.overflow = 'hidden';
        console.log('✅ Contenedor de imagen actualizado');
      }
    } else {
      console.error('❌ No se pudo encontrar contenedor padre para la imagen');
    }
  }

  ngOnDestroy() {
    this.clearLoadingChecks();
    if (this.dp) {
      this.dp.destroy();
    }
    this.videoElement = null;
  }

}
